import {
  collection,
  query,
  where,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";
import { db } from "./firebase";

const COL_NAME = "entries";

export async function upsertEntry(payload) {
  const { section, slug, titolo, descrizione, coverUrl, images } = payload;

  const q = query(
    collection(db, COL_NAME),
    where("section", "==", section),
    where("slug", "==", slug)
  );

  const snap = await getDocs(q);

  if (!snap.empty) {
    const ref = doc(db, COL_NAME, snap.docs[0].id);
    await updateDoc(ref, {
      titolo: titolo || "",
      descrizione: descrizione || "",
      coverUrl: coverUrl || "",
      images: Array.isArray(images) ? images : [],
      section,
      slug,
    });
    return snap.docs[0].id;
  }

  const res = await addDoc(collection(db, COL_NAME), {
    titolo: titolo || "",
    descrizione: descrizione || "",
    coverUrl: coverUrl || "",
    images: Array.isArray(images) ? images : [],
    section,
    slug,
  });

  return res.id;
}

export async function listEntriesBySection(section) {
  const q = query(collection(db, COL_NAME), where("section", "==", section));
  const snap = await getDocs(q);

  return snap.docs.map((d) => ({
    id: d.id,
    ...d.data(),
  }));
}

export async function getEntryBySectionSlug(section, slug) {
  const q = query(
    collection(db, COL_NAME),
    where("section", "==", section),
    where("slug", "==", slug)
  );

  const snap = await getDocs(q);

  if (snap.empty) return null;

  return {
    id: snap.docs[0].id,
    ...snap.docs[0].data(),
  };
}

export async function patchEntry(section, slug, partial) {
  const q = query(
    collection(db, COL_NAME),
    where("section", "==", section),
    where("slug", "==", slug)
  );

  const snap = await getDocs(q);
  if (snap.empty) throw new Error("Entry non trovata.");

  const ref = doc(db, COL_NAME, snap.docs[0].id);
  await updateDoc(ref, partial);
}

export async function deleteEntry(section, slug) {
  const q = query(
    collection(db, COL_NAME),
    where("section", "==", section),
    where("slug", "==", slug)
  );

  const snap = await getDocs(q);
  if (snap.empty) throw new Error("Entry non trovata.");

  const ref = doc(db, COL_NAME, snap.docs[0].id);
  await deleteDoc(ref);
}